export default function getTotalSvusOpportunity(
  completedActions,
  patientSvuSummaries,
) {
  return completedActions
    .map((action) => patientSvuSummaries[action.v2Dto.patientId] || 0)
    .reduce((total, patientSvuSummary) => total + patientSvuSummary, 0);
}
